import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import PropertiesListPage from '../components/PropertiesListPage'
import {
  actionCreators,
  IPropertiesListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectOrderBy,
  selectPropertyTypes,
  selectSortOrder,
  selectTotalItems,
} from '../modules/propertiesList'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IPropertiesListState & IGlobalConfigurationState
    >({
      configuration: selectConfiguration(),
      error: selectError(),
      filterText: selectFilterText(),
      isLoading: selectIsLoading(),
      items: selectItems(),
      orderBy: selectOrderBy(),
      propertyTypes: selectPropertyTypes(),
      sortOrder: selectSortOrder(),
      totalItems: selectTotalItems(),
    }),
    actionCreators,
  )(PropertiesListPage),
)
